/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MerchantEligibilityType,
    MerchantEligibilityTypeFromJSON,
    MerchantEligibilityTypeFromJSONTyped,
    MerchantEligibilityTypeToJSON,
    MerchantListGroup,
    MerchantListGroupFromJSON,
    MerchantListGroupFromJSONTyped,
    MerchantListGroupToJSON,
    MerchantRadiusUnit,
    MerchantRadiusUnitFromJSON,
    MerchantRadiusUnitFromJSONTyped,
    MerchantRadiusUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface IncentivePlanMerchantEligibility
 */
export interface IncentivePlanMerchantEligibility {
    /**
     * 
     * @type {MerchantEligibilityType}
     * @memberof IncentivePlanMerchantEligibility
     */
    type?: MerchantEligibilityType;
    /**
     * 
     * @type {MerchantListGroup}
     * @memberof IncentivePlanMerchantEligibility
     */
    merchantListGroup?: MerchantListGroup;
    /**
     * If the merchant eligibility type is RADIUS, indicates the maximum distance, in meters, of eligible merchants, otherwise, this field is ignored
     * @type {number}
     * @memberof IncentivePlanMerchantEligibility
     */
    merchantRadius?: number;
    /**
     * 
     * @type {MerchantRadiusUnit}
     * @memberof IncentivePlanMerchantEligibility
     */
    merchantRadiusUnit?: MerchantRadiusUnit;
}

export function IncentivePlanMerchantEligibilityFromJSON(json: any): IncentivePlanMerchantEligibility {
    return IncentivePlanMerchantEligibilityFromJSONTyped(json, false);
}

export function IncentivePlanMerchantEligibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncentivePlanMerchantEligibility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : MerchantEligibilityTypeFromJSON(json['type']),
        'merchantListGroup': !exists(json, 'merchantListGroup') ? undefined : MerchantListGroupFromJSON(json['merchantListGroup']),
        'merchantRadius': !exists(json, 'merchantRadius') ? undefined : json['merchantRadius'],
        'merchantRadiusUnit': !exists(json, 'merchantRadiusUnit') ? undefined : MerchantRadiusUnitFromJSON(json['merchantRadiusUnit']),
    };
}

export function IncentivePlanMerchantEligibilityToJSON(value?: IncentivePlanMerchantEligibility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': MerchantEligibilityTypeToJSON(value.type),
        'merchantListGroup': MerchantListGroupToJSON(value.merchantListGroup),
        'merchantRadius': value.merchantRadius,
        'merchantRadiusUnit': MerchantRadiusUnitToJSON(value.merchantRadiusUnit),
    };
}


